import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { RequestOptions, Headers } from '@angular/http';
import { ApiService } from '../api.service';
import { InspectionsResults } from 'ri-api-client';
import { InspectionsResultsPost } from 'ri-api-client';

@Injectable()
export class InspectionsResultsService {
  private options: RequestOptions;

  constructor(
    private apiService: ApiService
  ) {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    this.options = new RequestOptions({ headers: headers });
    this.apiService.init();
  }

  getInspectionsResultsOptions(): Observable<any[]> {
    return this.apiService.client.inspectionsResults.options.GET(this.options)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getInspectionsResultsSearch(query: InspectionsResultsPost.InspectionsResultsPost): Observable<InspectionsResults.InspectionsResults> {
    // If request url exceeds the 2k limit use post/get by id instead of get
    const size = (query.total || '').length +
      (query.groupBy || '').length +
      (query.filter || '').length +
      (query.ucFilter || '').length +
      (query.indicators || []).join().length;

    const postProcess = this.processInspectionResultsSearchResponse.bind(this);
    // Leave a reasonable error margin due to extra encoding chars and base url
    if (size > 1500) {
      return this.apiService.client.inspectionsResults.search.POST(query, this.options)
        .map(postProcess);
    }

    return this.apiService.client.inspectionsResults.search.GET(query.total, query.groupBy, (query.indicators || []).join(), query.ucFilter, query.filter, this.options)
      .map(postProcess);
  }

  private processInspectionResultsSearchResponse(res: any) {
    const response = this.apiService.handleResponse(res);
    if (response.inspectionsResultsData) {
      this.fillEmptySpots(response);
    }
    return response;
  }

  private fillEmptySpots(data: InspectionsResults.InspectionsResults) {
    const indicators: any = {};
    data.inspectionsResultsData.map( group => {
      if (group.indicators && group.indicators.length) {
        group.indicators.map( (indicator) => {
          indicators[indicator.name] = true;
        });
      }
    });
    data.inspectionsResultsData = data.inspectionsResultsData.map( group => {
      if (group.indicators && group.indicators.length) {
        for (const key in indicators) {
          if (indicators.hasOwnProperty(key) && !group.indicators.find( value => value.name === key)) {
            group.indicators.push({
              name: key,
              value: null
            });
          }
        }
      }
      return group;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/api/inspections-results.service.ts